export default __webpack_public_path__ + "static/level-specs-208483634a150d9238f18baaf0265e41.jpg";